import { Route, Routes } from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTop";

import HomePage from "./pages/Home/home";
import SobrePage from "./pages/Sobre/sobre";
import ServicosPage from "./pages/Servicos/servicos";
import EquipePage from "./pages/Equipe/equipe";
import ClientesPage from "./pages/Clientes/clientes";
import InsightsPage from "./pages/Insights/insights";
import ContatoPage from "./pages/Contato/contato";

import RweAnalytics from "./pages/Servicos/TruevAnalytics/rwe-analytics";
import StrategicPlanning from "./pages/Servicos/StrategicPlanning/strategic-planning";
import TrainingsWorkshops from "./pages/Servicos/TrainingsWorkshops/trainings-workshops";
import ScientificWritingCommunication from "./pages/Servicos/ScientificWritingCommunication/scientific-writing-communication";
import Masterclass from "./pages/Servicos/Masterclass/masterclass";

import PerfilRodrigo from "./pages/Equipe/PerfilRodrigo/perfil-rodrigo";
import PerfilMiriam from "./pages/Equipe/PerfilMiriam/perfil-miriam";
import PerfilKarlyse from "./pages/Equipe/PerfilKarlyse/perfil-karlyse";
import InsightPost from "./pages/Insights/InsightPost/insight-post";

interface IProps {
  page: any;
  onHandlePages: any;
}

const AppRoutes = ({ page, onHandlePages }: IProps) => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={<HomePage page={page} onHandlePages={onHandlePages} />}
        />
        <Route
          path="/sobre"
          element={<SobrePage onHandlePages={onHandlePages} />}
        />

        {/* Equipe e Perfis */}
        <Route
          path="/produtos"
          element={<ServicosPage onHandlePages={onHandlePages} />}
        />
        <Route
          path="/produtos/strategic-planning"
          element={<StrategicPlanning />}
        />
        <Route path="/produtos/rwe-analytics" element={<RweAnalytics />} />
        <Route
          path="/produtos/trainings-workshops"
          element={<TrainingsWorkshops />}
        />
        <Route
          path="/produtos/scientific-writing-communication"
          element={<ScientificWritingCommunication />}
        />
        <Route path="/produtos/masterclasses" element={<Masterclass />} />

        {/* Equipe e Perfis */}
        <Route
          path="/equipe"
          element={<EquipePage onHandlePages={onHandlePages} />}
        />
        <Route
          path="/equipe/dr-rodrigo-antonini-ribeiro"
          element={<PerfilRodrigo />}
        />
        <Route
          path="/equipe/miriam-zago-marcolino"
          element={<PerfilMiriam />}
        />
        <Route
          path="/equipe/karlyse-claudino-belli"
          element={<PerfilKarlyse />}
        />

        <Route path="/clientes" element={<ClientesPage />} />
        <Route
          path="/insights"
          element={<InsightsPage onHandlePages={onHandlePages} />}
        />
        <Route path="/insights/post/:id" element={<InsightPost />} />
        <Route path="/contato" element={<ContatoPage />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
